import { render, staticRenderFns } from "./TaxOffice.vue?vue&type=template&id=69ebccd7&scoped=true"
import script from "./TaxOffice.vue?vue&type=script&lang=js"
export * from "./TaxOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ebccd7",
  null
  
)

export default component.exports